module.exports = __webpack_public_path__ + "static/media/loupe_green_light.f3561d14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/loupe_green_light.svg
// module id = 38
// module chunks = 0